import { V2Subscriptions } from 'app/api/types';

import { useAppDataContext } from './private/useAppDataContext';

export const useSubscriptions = (): V2Subscriptions => {
    return useAppDataContext().subscriptions;
};
